import React from 'react'

function Profile() {
  return (
    <div className='py-[28px]'>Profile</div>
  )
}

export default Profile